import { faCheck } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { cn } from "@tosize/ui";
import { Accordion } from "radix-ui";
import { useCardContext } from "../../context/CardContext";
import styles from "./Step.module.css";

interface StepProps extends Accordion.AccordionItemProps {
	title: string;
	selectedValue?: string;
	selected?: boolean;
	disabled?: boolean;
	className?: string;
}

export function Step(props: StepProps) {
	const { invalidCards } = useCardContext();
	const { title, selectedValue, children, selected = false, className, ...itemProps } = props;
	const isInvalid = invalidCards?.includes(itemProps.value);

	return (
		<Accordion.Item
			className={styles.root}
			{...itemProps}
			data-card={itemProps.value}
			data-selected={selected}
		>
			<Accordion.Header>
				<Accordion.Trigger
					className={cn(
						"flex w-full items-center justify-between border-x border-t focus:outline-none focus-visible:ring-1 focus-visible:ring-inset",
						"disabled:cursor-not-allowed",
						{
							"border-transparent": !isInvalid,
							"focus-visible:!ring-danger border-danger": isInvalid,
						},
						styles.trigger,
					)}
				>
					<div className="mr-1 flex w-full items-center space-x-2">
						<span className="inline-flex h-4 w-4 shrink-0 items-center justify-center">
							<span
								className={cn(
									styles.check,
									"flex h-full w-full items-center justify-center rounded-full bg-white",
								)}
							>
								{selected && !isInvalid && (
									<FontAwesomeIcon
										icon={faCheck}
										className="translate-x-[2px] translate-y-[-1px] transform text-success text-xl"
										fixedWidth
									/>
								)}
							</span>
						</span>
						<span className="flex w-full flex-wrap items-center justify-between text-left">
							<span className={cn("mr-2", { "text-shades-dark": props.disabled })}>{title}</span>
							{!!selectedValue && (
								<span className="text-primary-medium text-sm leading-none">{selectedValue}</span>
							)}
						</span>
					</div>

					{/* <div>
            <span
              className={cn(
                'inline-block w-5 transform',
                { 'text-white': !selectedValue },
                styles.icon
              )}
            >
              <FontAwesomeIcon icon={faChevronDown} fixedWidth />
            </span>
          </div> */}
				</Accordion.Trigger>
			</Accordion.Header>
			<Accordion.Content
				className={cn(
					"space-y-4 rounded-b-xl border-x border-b bg-white",
					"p-2 sm:px-9 sm:py-4 lg:px-2 xl:px-9 xl:py-4",
					{
						"border-transparent": !isInvalid,
						"border-danger": isInvalid,
					},
					className,
				)}
			>
				{children}
			</Accordion.Content>
		</Accordion.Item>
	);
}
